import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';
import useWindowDimensions from '../Hooks/useWindowDimensions';
import isEmail from "validator/lib/isEmail";

import "../App.scss";

const Invite = () => {

  let navigate                              = useNavigate();
  const { id }                              = useParams();

  const [isSaving, setIsSaving]             = React.useState(false);
  const [isFormValid, setIsFormValid]       = React.useState(false);

  // const [list, setList]                     = useState([]);
  const [invitees, setInvitees]             = useState([]);
  const [firstRowName, setFirstRowName]     = useState("");
  const [firstRowEmail, setFirstRowEmail]   = useState("");
  const { windowWidth }               = useWindowDimensions();

  useEffect(() => {
    let invitee = [{
      id: 1,
      name: "",
      email: "",
      showFullName: false,
      showEmail: false
    }];
    setInvitees(invitee);
    document.body.style.backgroundColor = windowWidth <= 830 ? "#007670" : "#E5E5E5";
  }, [windowWidth]);
  
  // This regex allows for letters (including accents), apostrophes, and hyphens in full names, and requires at least two name parts separated by spaces.
  const fullNameRegex = /^([A-Za-zÀ-ÖØ-öø-ÿ'-]+ +)+[A-Za-zÀ-ÖØ-öø-ÿ'-]+$/;
  
  const submitToApi = (member) => {

    const payload = {
      members: member
    }
    
    fetch(process.env.REACT_APP_API_URI + '/v1/assessment/share/' + id, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => {
      return response.json();
    }).then(data => {
      if(data.status == "success") {
        navigate("/invite-team-thanks/" + id, { replace: true });
      } else {
        setIsSaving(false);
        // setOpenSnackbar(true);
      }
    });

  }

  const handleSubmit = () => {
    setIsSaving(true);

    let formHasError = false;
  
    const updatedInvitees = invitees.map((invitee) => {
      let showFullName = false;
      let showEmail = false;
      if (!invitee.name || !fullNameRegex.test(invitee.name.trim())) {
        showFullName = true;
        formHasError = true;
      }
      if (!invitee.email || !isEmail(invitee.email)) {
        showEmail = true;
        formHasError = true;
      }
      return { ...invitee, showFullName, showEmail };
    });
    setInvitees(updatedInvitees);
    if (formHasError) {
      setTimeout(() => { setIsSaving(false); }, 500);
    } else {
      submitToApi(updatedInvitees);
    }
  };  

  const deletePerson = (p) => {    
    setInvitees(invitees.filter((person) => {
      return person.id !== p
    }));
  };

  const addPerson = () => {
    
    let id        = 2;
    if(invitees.length > 0) {
      id          = invitees[invitees.length - 1].id + 1;
    }
    
    let person = {
      id: id,
      name: "",
      email: ""
    }
    setInvitees([...invitees, person]);

  };

  const updateName = (e, id) => {
    let currentMember       = invitees.find(function (obj) { return obj.id == id; });
    currentMember.name      = e.target.value;
  }

  const updateEmail = (e, id) => {
    let currentMember       = invitees.find(function (obj) { return obj.id == id; });
    currentMember.email     = e.target.value;
  }

  const showButton = () => {
    if(isSaving) {
      return <div className="button-progress"><CircularProgress style={{'color': '#fff'}} size={23} /></div>
    }
    return "SEND INVITE";
  }

  const removeError = (id, field, e) => {

    // change active input field title color 
    if(e.target.closest(".form-detail")) {
      document.body.querySelectorAll(".input-title").forEach(elm => elm.style.color = "#27282A")
      e.target.closest(".form-detail").querySelector(".input-title").style.color = "#3EB1C8";
    }

    let newinvitees = [];
    invitees.forEach(invitee => {
      if(field == "fullName" && invitee.id == id) {
        invitee.showFullName = false;
      }
      if(field == "email" && invitee.id == id) {
        invitee.showEmail = false;
      }
      newinvitees.push(invitee);
    });
    setInvitees(newinvitees);
  }


  return (
    <>
      <div className="container invite">
        <div className="details-container">
          <h1>Invite your team to take this test</h1>
          <p className="invite-text">Invite your team and see everyone’s responses on 1 dashboard.</p>
          {/* <p>Send individualized links to your Board Members to request they take the assessment.</p> */}
          {/* <p>Their results will populate your dashboard and as the Head of School, you'll see how the entire leadership team of the Board + Head of School aligns individually and collectively.</p> */}
          
          <div className="form-container" style={{paddingTop:'1.5rem'}}>
          {
            invitees.map((data, index) => (
              <>
              <div className="form _form" key={data.id}>        
                <div className="invite-number">{index + 1}.</div>        
                <div className="form-detail">
                  <p className="input-title">Full Name<span className="required-field" style={{color : "red"}}>*</span></p>
                  <TextField hiddenLabel placeholder="E.g. Simon Peter" onFocus={(e) => {removeError(data.id, "fullName", e)}} onChange={(e) => {updateName(e, data.id)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }}  className="invite-field" />
                  { 
                    data.showFullName ?
                      <div className="error-text">Please enter full name.</div>
                    : null
                  }
                </div>
                <div className="form-detail">
                  <p className="input-title">Email<span className="required-field" style={{color : "red"}}>*</span></p>
                  <TextField hiddenLabel placeholder="E.g. simon@petra.church" onFocus={(e) => {removeError(data.id, "email", e)}} onChange={(e) => {updateEmail(e, data.id)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }}  className="invite-field" />
                  { 
                    data.showEmail ?
                      <div className="error-text">Please enter a valid email address.</div>
                    : null
                  }
                </div>
                { data.id != 1 ?
                  <div className="delete-btn">
                    <div onClick={() => deletePerson(data.id)}>
                      <DeleteIcon className="delete-icon" />
                    </div>
                  </div>
                  : null
                }
              </div>
              <div className="hr-line"></div>
              </>
            ))
          }
          </div>
          <div className="button-container">
            <div className="invite-another-person">
              <div className="invite-another">
                <div className="form_icons--icon" >
                  <Button onClick={addPerson} className="add-btn" >
                    <AddIcon className="invite-another-icon" />ADD&nbsp;
                  </Button>
                </div>
              </div>
            </div>
          
            <Button className="cta-btn" disabled={isSaving} onClick={() => handleSubmit()}>{showButton()}</Button>
          </div>

        </div>
      </div>
    </>
  );

};
export default Invite;